import React, { useState } from "react";
import { Button, Modal, notification, Form, Switch, Card } from "antd";
import { XIcon, XSquareIcon, } from "@phosphor-icons/react";
import { FormattedMessage, useIntl } from "react-intl";
import { DisableUserMFA } from '../../../services/users';

const DisableUserMFAModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    refreshData,
    userID,
    history
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const intl = useIntl();

    const onSubmit = () => {
        setButtonDisabled(true);
        setConfirmDelete(false);

        DisableUserMFA({ user_id: userID }, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'MFA settings',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                } else {
                    notification['warning']({
                        message: 'MFA settings',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                }
                modalIsOpenHandler(false);
                refreshData();
            })
            .catch(error => {

                notification['error']({
                    message: 'MFA settings',
                    description: "Error loading customer data. Please refresh browser and try again!",
                });

                setButtonDisabled(false);
            });
    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><XSquareIcon size={18} weight="light" /> <FormattedMessage id="disable-mfa-header" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            className="danger"
            // bodyStyle={{ backgroundColor: '#cf1322', color: '#fff' }}
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<XIcon size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    danger={true}
                    type="primary"
                    loading={buttonDisabled}
                    disabled={!confirmDelete}
                    onClick={onSubmit}
                    icon={<XSquareIcon size={16} weight="light" />}>
                    <FormattedMessage id="mfa-disable" /></Button>,
            ]}>


            <Card
                className="my-4"
                title={<><><FormattedMessage id="disable-mfa-header" />?</></>}>
                <p><FormattedMessage id="disable-mfa-info" /></p>
                <Form
                // labelCol={{ span: 20 }}
                // wrapperCol={{ span: 4 }}
                >

                    <Form.Item label={<FormattedMessage id="disable-mfa-confirm" />}>
                        <Switch
                            className="danger"
                            checked={confirmDelete}
                            onChange={e => setConfirmDelete(!confirmDelete)}
                        />
                    </Form.Item>

                </Form>
            </Card>

        </Modal>
    );
};


export default DisableUserMFAModal;
